import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SidenavItemInner } from './Sidenav.Item.Inner.es.js';
import { SidenavItemTooltip } from './Sidenav.Item.Tooltip.es.js';

const SidenavItemRow = ({ name, active = false, collapsible = false, children, className, ...props })=>{
    return jsx(SidenavItemTooltip, {
        content: children,
        children: jsx("div", {
            className: classNames('cb-sidenav-item', className, {
                active,
                collapsible
            }),
            ...props,
            children: jsx(SidenavItemInner, {
                name: name,
                children: children
            })
        })
    });
};
SidenavItemRow.displayName = 'Sidenav.Item.Row';

export { SidenavItemRow };
//# sourceMappingURL=Sidenav.Item.Row.es.js.map
